/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 3/11/2020
 */

import DbBaseObject from '@shared/DbBaseObject.js';
import {Type} from "class-transformer";
import FunnelEntryItem from "@/core/modules/coach/Clients/Funnel/model/old/FunnelEntryItem";



export default class FunnelColumnItem extends DbBaseObject{


	title: string = ""

	// @Type(() => ClientProfile)
	// clientProfiles: ClientProfile[] = []

	@Type(() => FunnelEntryItem)
	_entryArray: FunnelEntryItem[] = []




	constructor() {
		super();
	}

	findFunnelEntryIndexById(funnelEntryId){
		return this._entryArray.findIndex(entryArray => entryArray.id === funnelEntryId)
	}

	findClientProfileIndexById(clientProfileId){
		return this._entryArray.findIndex(entryArray => entryArray.clientProfile ? entryArray.clientProfile.id === clientProfileId : false)
	}

	findClientProfileIndexByEmail(email){
		return this._entryArray.findIndex(entryArray => entryArray.clientProfile ? entryArray.clientProfile.email === email : false)
	}

	createFunnelEntry(){
		let funnelEntry = new FunnelEntryItem()
		funnelEntry.columnId = this.id
		funnelEntry.index = new Date().getTime() * 10000
		return funnelEntry
	}

}



